import { StepAction } from './stepAction';
import type { SubmitStep } from 'clickim/src/common/models/submitStep';

export class SubmitStepAction extends StepAction<SubmitStep> {
    override async performAction() {
        await this.driver.submit(this.getTarget().seleniumElement);
    }
}
